module.exports = __webpack_public_path__ + "static/media/gabriel_how.fadb73b6.mp3";